export const gameTypeChoiceMessages = {
  'zh-CN': {
    title: '请选择游戏版本', hint: '未能自动确认游戏版本。请选择当前窗口中的游戏，之后会记住你的选择。',
    multipleTitle: '请只共享一个游戏界面', multipleHint: '检测到多个完整游戏界面。请重新选择单个游戏窗口，或缩小共享范围后重试。',
    label: '当前游戏版本', confirm: '使用此版本', retry: '重新自动识别', close: '暂时关闭', reselect: '重新选择窗口',
  },
  'zh-TW': {
    title: '請選擇遊戲版本', hint: '無法自動確認遊戲版本。請選擇目前視窗中的遊戲，之後會記住你的選擇。',
    multipleTitle: '請只分享一個遊戲畫面', multipleHint: '偵測到多個完整遊戲畫面。請重新選擇單一遊戲視窗，或縮小分享範圍後重試。',
    label: '目前遊戲版本', confirm: '使用此版本', retry: '重新自動辨識', close: '暫時關閉', reselect: '重新選擇視窗',
  },
  en: {
    title: 'Choose your game version', hint: 'The game version could not be confirmed automatically. Choose the game in this window. Your choice will be remembered.',
    multipleTitle: 'Share one game interface', multipleHint: 'Multiple complete game interfaces were found. Select a single game window or reduce the shared area, then try again.',
    label: 'Current game version', confirm: 'Use this version', retry: 'Detect automatically again', close: 'Close for now', reselect: 'Select another window',
  },
  ja: {
    title: 'ゲームのバージョンを選択', hint: 'ゲームのバージョンを自動で確認できませんでした。このウィンドウのゲームを選択してください。選択内容は保存されます。',
    multipleTitle: 'ゲーム画面を1つだけ共有してください', multipleHint: '複数のゲーム画面が見つかりました。ゲームのウィンドウを1つ選ぶか、共有範囲を狭めてから再試行してください。',
    label: '現在のゲームバージョン', confirm: 'このバージョンを使用', retry: '自動判別を再試行', close: 'いったん閉じる', reselect: 'ウィンドウを選び直す',
  },
  ko: {
    title: '게임 버전 선택', hint: '게임 버전을 자동으로 확인하지 못했습니다. 이 창의 게임을 선택해 주세요. 선택한 버전은 저장됩니다.',
    multipleTitle: '게임 화면 하나만 공유해 주세요', multipleHint: '여러 게임 화면을 찾았습니다. 게임 창 하나를 다시 선택하거나 공유 범위를 줄인 후 다시 시도해 주세요.',
    label: '현재 게임 버전', confirm: '이 버전 사용', retry: '자동 감지 다시 시도', close: '나중에 선택', reselect: '창 다시 선택',
  },
} as const
